import _definePage_default_0 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/index.vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/[...path].vue?definePage&vue&lang.tsx'
import _definePage_default_3 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/dashboard.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/schools.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/schools.[id].details.vue?definePage&vue&lang.tsx'
import _definePage_default_7 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/system.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/system/skills.vue?definePage&vue&lang.tsx'
import _definePage_default_9 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/system/subjects.vue?definePage&vue&lang.tsx'
import _definePage_default_10 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/teachers.vue?definePage&vue&lang.tsx'
import _definePage_default_11 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/teachers/[id].profile.vue?definePage&vue&lang.tsx'
import _definePage_default_12 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/teachers/[id].public-profile.vue?definePage&vue&lang.tsx'
import _definePage_default_13 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/teachers/all.vue?definePage&vue&lang.tsx'
import _definePage_default_14 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/teachers/pending.vue?definePage&vue&lang.tsx'
import _definePage_default_15 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/temp.vue?definePage&vue&lang.tsx'
import _definePage_default_16 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/temp/index.vue?definePage&vue&lang.tsx'
import _definePage_default_17 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/auth.vue?definePage&vue&lang.tsx'
import _definePage_default_18 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/auth/login.vue?definePage&vue&lang.tsx'
import _definePage_default_19 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/auth/password-recovery.vue?definePage&vue&lang.tsx'
import _definePage_default_20 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/auth/register.vue?definePage&vue&lang.tsx'
import _definePage_default_21 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/auth/validation.vue?definePage&vue&lang.tsx'
import _definePage_default_22 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school.vue?definePage&vue&lang.tsx'
import _definePage_default_23 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/class-management.vue?definePage&vue&lang.tsx'
import _definePage_default_24 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/class-management/calendar.vue?definePage&vue&lang.tsx'
import _definePage_default_25 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/class-management/class-requests.vue?definePage&vue&lang.tsx'
import _definePage_default_26 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/school-setup.vue?definePage&vue&lang.tsx'
import _definePage_default_27 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/school-setup/programs.vue?definePage&vue&lang.tsx'
import _definePage_default_28 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/school-setup/public-page-management.vue?definePage&vue&lang.tsx'
import _definePage_default_29 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/school-setup/school-administrators.vue?definePage&vue&lang.tsx'
import _definePage_default_30 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/school-setup/school-location.vue?definePage&vue&lang.tsx'
import _definePage_default_31 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/teacher-search.vue?definePage&vue&lang.tsx'
import _definePage_default_32 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/teacher-search/general-search.vue?definePage&vue&lang.tsx'
import _definePage_default_33 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/teacher-search/hired-teachers.vue?definePage&vue&lang.tsx'
import _definePage_default_34 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/teacher-individual-profile.[id].vue?definePage&vue&lang.tsx'
import _definePage_default_35 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher.vue?definePage&vue&lang.tsx'
import _definePage_default_36 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/calendar.vue?definePage&vue&lang.tsx'
import _definePage_default_37 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/dashboard.vue?definePage&vue&lang.tsx'
import _definePage_default_38 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/profile.vue?definePage&vue&lang.tsx'
import _definePage_default_39 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/profile/documents.vue?definePage&vue&lang.tsx'
import _definePage_default_40 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/profile/education-background.vue?definePage&vue&lang.tsx'
import _definePage_default_41 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/profile/general-info.vue?definePage&vue&lang.tsx'
import _definePage_default_42 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/profile/teaching-experience.vue?definePage&vue&lang.tsx'
import _definePage_default_43 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/profile/teaching-info.vue?definePage&vue&lang.tsx'
import _definePage_default_44 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/profile/working-experience.vue?definePage&vue&lang.tsx'
import _definePage_default_45 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/public-profile.vue?definePage&vue&lang.tsx'
import _definePage_default_46 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/requests.vue?definePage&vue&lang.tsx'
import _definePage_default_47 from 'C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/school-profile/[id].vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
    {
      path: '/',
      name: 'base',
      component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/index.vue'),
      /* no children */
    },
    _definePage_default_0
  ),
  _mergeRouteRecord(
    {
      path: '/:path(.*)',
      name: 'CatchAllPage',
      component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/[...path].vue'),
      /* no children */
    },
    _definePage_default_2
  ),
  _mergeRouteRecord(
    {
      path: '/admin',
      name: 'admin',
      component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin.vue'),
      children: [
        _mergeRouteRecord(
          {
            path: 'dashboard',
            name: 'admin.dashboard',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/dashboard.vue'),
            /* no children */
          },
          _definePage_default_4
        ),
        _mergeRouteRecord(
          {
            path: 'schools',
            name: 'admin.schools',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/schools.vue'),
            /* no children */
          },
          _definePage_default_5
        ),
        _mergeRouteRecord(
          {
            path: 'schools/:id/details',
            name: 'admin.schools.details',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/schools.[id].details.vue'),
            /* no children */
          },
          _definePage_default_6
        ),
        _mergeRouteRecord(
          {
            path: 'system',
            name: 'admin.system',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/system.vue'),
            children: [
              _mergeRouteRecord(
                {
                  path: 'skills',
                  name: 'admin.system.skills',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/system/skills.vue'),
                  /* no children */
                },
                _definePage_default_8
              ),
              _mergeRouteRecord(
                {
                  path: 'subjects',
                  name: 'admin.system.subjects',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/system/subjects.vue'),
                  /* no children */
                },
                _definePage_default_9
              )
            ],
          },
          _definePage_default_7
        ),
        _mergeRouteRecord(
          {
            path: 'teachers',
            name: 'admin.teachers',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/teachers.vue'),
            children: [
              _mergeRouteRecord(
                {
                  path: ':id/profile',
                  name: 'admin.teachers.profile',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/teachers/[id].profile.vue'),
                  /* no children */
                },
                _definePage_default_11
              ),
              _mergeRouteRecord(
                {
                  path: ':id/public-profile',
                  name: 'admin.teachers.public-profile',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/teachers/[id].public-profile.vue'),
                  /* no children */
                },
                _definePage_default_12
              ),
              _mergeRouteRecord(
                {
                  path: 'all',
                  name: 'admin.teachers.all',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/teachers/all.vue'),
                  /* no children */
                },
                _definePage_default_13
              ),
              _mergeRouteRecord(
                {
                  path: 'pending',
                  name: 'admin.teachers.pending',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/teachers/pending.vue'),
                  /* no children */
                },
                _definePage_default_14
              )
            ],
          },
          _definePage_default_10
        ),
        _mergeRouteRecord(
          {
            path: 'temp',
            name: 'admin.temp',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/temp.vue'),
            children: [
              _mergeRouteRecord(
                {
                  path: '',
                  name: 'admin.temp.dev',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/admin/temp/index.vue'),
                  /* no children */
                },
                _definePage_default_16
              )
            ],
          },
          _definePage_default_15
        )
      ],
    },
    _definePage_default_3
  ),
  _mergeRouteRecord(
    {
      path: '/auth',
      name: 'auth',
      component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/auth.vue'),
      children: [
        _mergeRouteRecord(
          {
            path: 'login',
            name: 'auth.login',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/auth/login.vue'),
            /* no children */
          },
          _definePage_default_18
        ),
        _mergeRouteRecord(
          {
            path: 'password-recovery',
            name: 'auth.reset-password',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/auth/password-recovery.vue'),
            /* no children */
          },
          _definePage_default_19
        ),
        _mergeRouteRecord(
          {
            path: 'register',
            name: 'auth.register',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/auth/register.vue'),
            /* no children */
          },
          _definePage_default_20
        ),
        _mergeRouteRecord(
          {
            path: 'validation',
            name: 'auth.validation',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/auth/validation.vue'),
            /* no children */
          },
          _definePage_default_21
        )
      ],
    },
    _definePage_default_17
  ),
  _mergeRouteRecord(
    {
      path: '/school',
      name: 'school',
      component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school.vue'),
      children: [
        _mergeRouteRecord(
          {
            path: '/school/class-management',
            name: 'school.class-management',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/class-management.vue'),
            children: [
              _mergeRouteRecord(
                {
                  path: 'calendar',
                  name: 'school.class-management.calendar',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/class-management/calendar.vue'),
                  /* no children */
                },
                _definePage_default_24
              ),
              _mergeRouteRecord(
                {
                  path: 'class-requests',
                  name: 'school.class-management.class-requests',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/class-management/class-requests.vue'),
                  /* no children */
                },
                _definePage_default_25
              )
            ],
          },
          _definePage_default_23
        ),
        _mergeRouteRecord(
          {
            path: '/school/school-setup',
            name: 'school.school-setup',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/school-setup.vue'),
            children: [
              _mergeRouteRecord(
                {
                  path: 'programs',
                  name: 'school.school-setup.programs',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/school-setup/programs.vue'),
                  /* no children */
                },
                _definePage_default_27
              ),
              _mergeRouteRecord(
                {
                  path: 'public-page-management',
                  name: 'school.school-setup.public-page-management',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/school-setup/public-page-management.vue'),
                  /* no children */
                },
                _definePage_default_28
              ),
              _mergeRouteRecord(
                {
                  path: 'school-administrators',
                  name: 'school.school-setup.school-administrators',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/school-setup/school-administrators.vue'),
                  /* no children */
                },
                _definePage_default_29
              ),
              _mergeRouteRecord(
                {
                  path: 'school-location',
                  name: 'school.school-setup.school-location',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/school-setup/school-location.vue'),
                  /* no children */
                },
                _definePage_default_30
              )
            ],
          },
          _definePage_default_26
        ),
        _mergeRouteRecord(
          {
            path: '/school/teacher-search',
            name: 'school.teacher-search',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/teacher-search.vue'),
            children: [
              _mergeRouteRecord(
                {
                  path: 'general-search',
                  name: 'school.teacher-search.general-search',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/teacher-search/general-search.vue'),
                  /* no children */
                },
                _definePage_default_32
              ),
              _mergeRouteRecord(
                {
                  path: 'hired-teachers',
                  name: 'school.teacher-search.hired-teachers',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/teacher-search/hired-teachers.vue'),
                  /* no children */
                },
                _definePage_default_33
              )
            ],
          },
          _definePage_default_31
        ),
        _mergeRouteRecord(
          {
            path: 'teacher-individual-profile/:id',
            name: 'school.teacher-search.teacher-indivual-profile',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/school/teacher-individual-profile.[id].vue'),
            /* no children */
          },
          _definePage_default_34
        )
      ],
    },
    _definePage_default_22
  ),
  _mergeRouteRecord(
    {
      path: '/teacher',
      name: 'teacher',
      component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher.vue'),
      children: [
        _mergeRouteRecord(
          {
            path: 'calendar',
            name: 'teacher.calendar',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/calendar.vue'),
            /* no children */
          },
          _definePage_default_36
        ),
        _mergeRouteRecord(
          {
            path: 'dashboard',
            name: 'teacher.dashboard',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/dashboard.vue'),
            /* no children */
          },
          _definePage_default_37
        ),
        _mergeRouteRecord(
          {
            path: 'profile',
            name: 'teacher.profile',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/profile.vue'),
            children: [
              _mergeRouteRecord(
                {
                  path: 'documents',
                  name: 'teacher.profile.documents',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/profile/documents.vue'),
                  /* no children */
                },
                _definePage_default_39
              ),
              _mergeRouteRecord(
                {
                  path: 'education-background',
                  name: 'teacher.profile.education-background',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/profile/education-background.vue'),
                  /* no children */
                },
                _definePage_default_40
              ),
              _mergeRouteRecord(
                {
                  path: 'general-info',
                  name: 'teacher.profile.general-info',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/profile/general-info.vue'),
                  /* no children */
                },
                _definePage_default_41
              ),
              _mergeRouteRecord(
                {
                  path: 'teaching-experience',
                  name: 'teacher.profile.teaching-experience',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/profile/teaching-experience.vue'),
                  /* no children */
                },
                _definePage_default_42
              ),
              _mergeRouteRecord(
                {
                  path: 'teaching-info',
                  name: 'teacher.profile.teaching-info',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/profile/teaching-info.vue'),
                  /* no children */
                },
                _definePage_default_43
              ),
              _mergeRouteRecord(
                {
                  path: 'working-experience',
                  name: 'teacher.profile.working-experience',
                  component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/profile/working-experience.vue'),
                  /* no children */
                },
                _definePage_default_44
              )
            ],
          },
          _definePage_default_38
        ),
        _mergeRouteRecord(
          {
            path: 'public-profile',
            name: 'teacher.public-profile',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/public-profile.vue'),
            /* no children */
          },
          _definePage_default_45
        ),
        _mergeRouteRecord(
          {
            path: 'requests',
            name: 'teacher.requests',
            component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/requests.vue'),
            /* no children */
          },
          _definePage_default_46
        ),
        {
          path: 'school-profile',
          /* internal name: '/teacher/school-profile' */
          /* no component */
          children: [
            _mergeRouteRecord(
              {
                path: ':id',
                name: 'teacher.school-profile',
                component: () => import('C:/Users/arthu/Desktop/dev/daidai-web/src/pages/teacher/school-profile/[id].vue'),
                /* no children */
              },
              _definePage_default_47
            )
          ],
        }
      ],
    },
    _definePage_default_35
  )
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

